/**
 * Default crypto payment configuration values
 * Shared between settings page and other components
 */

export const DEFAULT_CHAINS = [
  { id: "ethereum", label: "Ethereum", icon: "fab fa-ethereum" },
  { id: "polygon", label: "Polygon", icon: "fas fa-hexagon" },
  { id: "base", label: "Base", icon: "fas fa-cube" },
  { id: "arbitrum", label: "Arbitrum", icon: "fas fa-layer-group" },
  { id: "optimism", label: "Optimism", icon: "fas fa-rocket" },
];

export const DEFAULT_CURRENCIES = [
  { id: "USDC", label: "USDC", color: "#2775CA" },
  { id: "EURC", label: "EURC", color: "#0052FF" },
];

// Simple arrays for defaults (used in form state initialization)
export const DEFAULT_CHAIN_IDS = DEFAULT_CHAINS.map((c) => c.id);
export const DEFAULT_CURRENCY_IDS = DEFAULT_CURRENCIES.map((c) => c.id);

export const DEFAULT_MINIMUM_AMOUNT = 10;
